/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  DenyFollowRequestMutationResponse,
  DenyFollowRequestPathParams,
  DenyFollowRequest401,
  DenyFollowRequest403,
  DenyFollowRequest404,
} from "../types/DenyFollowRequest.ts"
import { denyFollowRequestMutationResponseSchema } from "../zod/denyFollowRequestSchema.ts"

function getDenyFollowRequestUrl(
  requestId: DenyFollowRequestPathParams["requestId"],
) {
  const res = {
    method: "PUT",
    url: `/follow-requests/${requestId}/deny` as const,
  }
  return res
}

/**
 * @summary Deny a follow request
 * {@link /follow-requests/:requestId/deny}
 */
export async function denyFollowRequest(
  requestId: DenyFollowRequestPathParams["requestId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DenyFollowRequestMutationResponse,
    ResponseErrorConfig<
      DenyFollowRequest401 | DenyFollowRequest403 | DenyFollowRequest404
    >,
    unknown
  >({
    method: "PUT",
    url: getDenyFollowRequestUrl(requestId).url.toString(),
    ...requestConfig,
  })
  return denyFollowRequestMutationResponseSchema.parse(res.data)
}
